<ng-container *transloco="let t">
  <ng-template #pageHeader>
    <h1 class="text-2xl font-semibold capitalize leading-[1.4] text-primary mb-3">
      {{ t('CONTRACT_ORDER.NEW_SIGNING_ORDER') }}
    </h1>
    <p class="text-sm text-ink-muted">
      {{ t('CONTRACT_ORDER.NEW_SIGNING_ORDER_SUBTITLE') }}
    </p>
  </ng-template>

  <form
    [formRoot]="createOrderForm"
    class="md:-mx-4 md:-mt-8 md:-mb-14 lg:-mx-13.5 lg:-my-9 flex flex-col md:flex-row md:items-stretch min-h-screen"
  >
    <div class="md:hidden mb-8 shrink-0">
      <ng-container [ngTemplateOutlet]="pageHeader"></ng-container>
    </div>

    <!-- Left: Documents panel -->
    <div class="md:w-[28%] lg:w-[30%] md:shrink-0 bg-surface-card rounded-lg md:rounded-none px-4 py-6">
      <dss-libs-ui-upload-file
        [dropzoneHasError]="createOrderForm.documents.count().touched() && createOrderForm.documents.count().invalid()"
        (filesUploadedListEvent)="filesUploadedListEvent($event)"
      ></dss-libs-ui-upload-file>
    </div>

    <!-- Right: form content -->
    <div
      class="md:flex-1 md:px-4 pt-8 pb-4 lg:px-13.5 lg:py-9 border-0 lg:border-s border-stroke-soft flex flex-col min-h-0"
    >
      <!-- Page header (desktop only) -->
      <div class="hidden md:block mb-8 shrink-0">
        <ng-container [ngTemplateOutlet]="pageHeader"></ng-container>
      </div>

      <!-- Insufficient signatures warning -->
      @if (showInsufficientSignaturesBanner()) {
      <div class="mb-8 shrink-0 flex items-center gap-2 overflow-hidden rounded-lg bg-warning-surface p-3">
        <mat-icon class="size-5! shrink-0 text-warning!" svgIcon="danger-triangle-bold"></mat-icon>
        <p class="flex-1 text-sm font-medium leading-[1.4] text-ink">
          {{ t('CONTRACT_ORDER.EXTRA_SIGNATURES_ARE_NEEDED') }}
        </p>
        <button
          type="button"
          class="flex size-6 shrink-0 items-center justify-center"
          [attr.aria-label]="t('DISMISS')"
          (click)="showInsufficientSignaturesBanner.set(false)"
        >
          <mat-icon class="size-2.5! text-ink-muted! cursor-pointer" svgIcon="close"></mat-icon>
        </button>
      </div>
      }

      <dss-libs-ui-tabs-group
        class="flex-1 min-h-0 flex flex-col"
        [isSubmitButtonEnabled]="!createOrderForm().submitting()"
        (discardTriggered)="onDiscardTriggered()"
        mainContainerClasses="flex flex-col flex-1 min-h-0 justify-between pb-4 md:pb-0"
        tabsContainerClasses="flex-1 min-h-0 overflow-auto p-0 lg:pe-2 mb-2"
        [tabIndexWithValidationError]="tabIndexWithValidationError()"
      >
        <dss-libs-ui-tab [title]="t('CONTRACT_ORDER.RECIPIENT_INFORMATION')">
          @if (subscriptionSignatures()) {
          <dss-libs-feature-recipient-information-form
            [form]="createOrderForm.recipientInformation"
            [subscriptionData]="subscriptionSignatures()!"
          ></dss-libs-feature-recipient-information-form>
          }
        </dss-libs-ui-tab>
        <dss-libs-ui-tab [title]="t('CONTRACT_ORDER.ORDER_SETTINGS')">
          <dss-libs-feature-order-settings
            [form]="createOrderForm.orderSettings"
            [expirationPeriods]="expirationPeriodList"
            [remindingPeriods]="reminderIntervalList"
            [signingMethods]="signingMethodsList()"
          ></dss-libs-feature-order-settings>
        </dss-libs-ui-tab>
        <dss-libs-ui-tab [title]="t('CONTRACT_ORDER.ORDER_MESSAGE')">
          <dss-libs-feature-order-message [form]="createOrderForm.orderMessage"></dss-libs-feature-order-message>
        </dss-libs-ui-tab>
      </dss-libs-ui-tabs-group>
    </div>
  </form>
</ng-container>
